<template>
  <div class="account-page login-modern register-modern">
    <div class="account-content">
      <div class="login-wrapper login-centered">
        <div class="login-content">
          <form @submit.prevent="onSubmit" class="register-form">
            <div class="login-userset">
              <div class="login-logo logo-normal">
                <img src="@/assets/img/logo.png" alt="img" />
              </div>
              <router-link to="/dashboard" class="login-logo logo-white">
                <img src="@/assets/img/logo-white.png" alt="" />
              </router-link>
              <p class="brand-tagline">
                NEDAM FACTURA | Préinscription entreprise
              </p>
              <div class="login-userheading">
                <h3>Inscription Société</h3>
                <h4>Un conseiller vous recontactera pour activer votre abonnement</h4>
              </div>

              <div
                v-if="companyEmailError || displayErrors.length"
                class="alert alert-warning d-flex align-items-start gap-2"
              >
                <i class="fas fa-info-circle mt-1"></i>
                <div>
                  <div v-if="companyEmailError">{{ companyEmailError }}</div>
                  <ul v-if="displayErrors.length" class="mb-0 ps-3">
                    <li v-for="err in displayErrors" :key="err">{{ err }}</li>
                  </ul>
                </div>
              </div>

              <div class="section-divider">
                <h5><i class="fas fa-building me-2"></i>Informations société</h5>
                <p class="text-muted mb-0">Renseignez les informations légales de votre entreprise.</p>
              </div>

              <div class="form-login">
                <label>Nom de la société<span class="text-danger">*</span></label>
                <div class="form-addons">
                  <input type="text" class="form-control" v-model.trim="form.company_name" required />
                </div>
              </div>

              <div class="form-login">
                <label>Email de la société<span class="text-danger">*</span></label>
                <div class="form-addons">
                  <input
                    type="email"
                    class="form-control"
                    :class="{ 'is-invalid': companyEmailError }"
                    v-model.trim="form.company_email"
                    required
                  />
                </div>
                <div v-if="companyEmailError" class="invalid-feedback d-block">
                  {{ companyEmailError }}
                </div>
              </div>

              <div class="form-login">
                <label>Téléphone<span class="text-danger">*</span></label>
                <div class="form-addons">
                  <input type="text" class="form-control" v-model.trim="form.company_phone" required />
                </div>
              </div>

              <div class="form-login">
                <label>Adresse (facultatif)</label>
                <div class="form-addons">
                  <textarea class="form-control" rows="2" v-model.trim="form.company_address"></textarea>
                </div>
              </div>

              <div class="form-login">
                <label>RC <small class="text-muted">(Registre de commerce)</small></label>
                <div class="form-addons">
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': fieldErrors.rc }"
                    v-model.trim="form.rc"
                  />
                </div>
                <div v-if="fieldErrors.rc" class="invalid-feedback d-block">
                  {{ fieldErrors.rc }}
                </div>
              </div>

              <div class="form-login">
                <label>ICE <small class="text-muted">(Identifiant Commun de l'Entreprise)</small></label>
                <div class="form-addons">
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': fieldErrors.ice }"
                    v-model.trim="form.ice"
                  />
                </div>
                <div v-if="fieldErrors.ice" class="invalid-feedback d-block">
                  {{ fieldErrors.ice }}
                </div>
              </div>

              <div class="form-login">
                <label>TP <small class="text-muted">(Taxe professionnelle)</small></label>
                <div class="form-addons">
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': fieldErrors.tp }"
                    v-model.trim="form.tp"
                  />
                </div>
                <div v-if="fieldErrors.tp" class="invalid-feedback d-block">
                  {{ fieldErrors.tp }}
                </div>
              </div>

              <div class="form-login">
                <label>Identifiant fiscal</label>
                <div class="form-addons">
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': fieldErrors.identifiant_fiscal }"
                    v-model.trim="form.identifiant_fiscal"
                  />
                </div>
                <div v-if="fieldErrors.identifiant_fiscal" class="invalid-feedback d-block">
                  {{ fieldErrors.identifiant_fiscal }}
                </div>
              </div>

              <div class="section-divider">
                <h5><i class="fas fa-user-tie me-2"></i>Personne de contact</h5>
                <p class="text-muted mb-0">Le responsable qui recevra les communications de notre équipe.</p>
              </div>

              <div class="form-login">
                <label>Nom complet<span class="text-danger">*</span></label>
                <div class="form-addons">
                  <input type="text" class="form-control" v-model.trim="form.contact_name" required />
                </div>
              </div>

              <div class="form-login">
                <label>Email du contact<span class="text-danger">*</span></label>
                <div class="form-addons">
                  <input type="email" class="form-control" v-model.trim="form.contact_email" required />
                </div>
              </div>

              <div class="section-divider">
                <h5><i class="fas fa-shield-alt me-2"></i>Sécurité du compte</h5>
                <p class="text-muted mb-0">Choisissez un mot de passe robuste pour sécuriser l'accès.</p>
              </div>

              <div class="form-login">
                <label>Mot de passe<span class="text-danger">*</span></label>
                <div class="pass-group">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    class="pass-input"
                    v-model="form.password"
                    minlength="8"
                    required
                  />
                  <span
                    class="fas toggle-password"
                    :class="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                    @click="togglePassword"
                  ></span>
                </div>
                <small class="text-muted">Minimum 8 caractères, incluant chiffres et lettres.</small>
              </div>

              <div class="form-login">
                <label>Confirmer le mot de passe<span class="text-danger">*</span></label>
                <div class="pass-group">
                  <input
                    :type="showConfirmPassword ? 'text' : 'password'"
                    class="pass-inputs"
                    v-model="form.password_confirmation"
                    minlength="8"
                    required
                  />
                  <span
                    class="fas toggle-passwords"
                    :class="showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'"
                    @click="toggleConfirm"
                  ></span>
                </div>
              </div>

              <div class="section-divider">
                <h5><i class="fas fa-comment-dots me-2"></i>Informations complémentaires</h5>
              </div>

              <div class="form-login">
                <label>Notes pour le support (facultatif)</label>
                <textarea
                  class="form-control"
                  rows="3"
                  v-model.trim="form.notes"
                  placeholder="Indiquez votre secteur d'activité, besoins spécifiques, etc."
                ></textarea>
              </div>

              <div class="form-login authentication-check">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="custom-control custom-checkbox justify-content-start">
                      <label class="checkboxs ps-4 mb-0 pb-0 line-height-1">
                        <input type="checkbox" v-model="acceptTerms" />
                        <span class="checkmarks"></span>J'accepte les
                        <a href="javascript:void(0);" class="hover-a">conditions générales et la politique de confidentialité</a>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-login mt-3">
                <button type="submit" class="btn btn-login" :disabled="isSubmitDisabled">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  {{ loading ? "Envoi..." : "Envoyer la demande" }}
                </button>
              </div>
              <div class="signinform">
                <h4>
                  Vous avez déjà un compte ?
                  <router-link to="/" class="hover-a">Connectez-vous</router-link>
                </h4>
              </div>
              <div
                class="my-4 d-flex justify-content-center align-items-center copyright-text"
              >
                <p>
                  Nous examinons chaque demande sous 24h ouvrées. Vous recevrez un email dès qu'un conseiller aura pris en charge votre dossier.
                </p>
              </div>
            </div>
          </form>
        </div>
        <div class="login-img">
          <img src="@/assets/img/authentication/register02.jpg" alt="img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref, computed, watch } from "vue";
import { toast } from "vue3-toastify";
import { submitExternalSignup } from "@/services/externalSignupService";

export default {
  name: "ExternalSignup",
  setup() {
    const loading = ref(false);
    const showPassword = ref(false);
    const showConfirmPassword = ref(false);
    const acceptTerms = ref(false);
    const form = reactive({
      company_name: "",
      company_email: "",
      company_phone: "",
      company_address: "",
      rc: "",
      ice: "",
      tp: "",
      identifiant_fiscal: "",
      contact_name: "",
      contact_email: "",
      password: "",
      password_confirmation: "",
      notes: "",
    });

    const togglePassword = () => {
      showPassword.value = !showPassword.value;
    };

    const toggleConfirm = () => {
      showConfirmPassword.value = !showConfirmPassword.value;
    };

    const resetForm = () => {
      form.company_name = "";
      form.company_email = "";
      form.company_phone = "";
      form.company_address = "";
      form.rc = "";
      form.ice = "";
      form.tp = "";
      form.identifiant_fiscal = "";
      form.contact_name = "";
      form.contact_email = "";
      form.password = "";
      form.password_confirmation = "";
      form.notes = "";
      acceptTerms.value = false;
      companyEmailError.value = "";
      fieldErrors.rc = "";
      fieldErrors.ice = "";
      fieldErrors.tp = "";
      fieldErrors.identifiant_fiscal = "";
    };

    const companyEmailError = ref("");
    const fieldErrors = reactive({
      rc: "",
      ice: "",
      tp: "",
      identifiant_fiscal: "",
    });

    const displayErrors = computed(() =>
      Object.values(fieldErrors).filter((message) => Boolean(message))
    );

    const isSubmitDisabled = computed(() => loading.value || !acceptTerms.value);

    const onSubmit = async () => {
      companyEmailError.value = "";
      fieldErrors.rc = "";
      fieldErrors.ice = "";
      fieldErrors.tp = "";
      fieldErrors.identifiant_fiscal = "";

      if (!acceptTerms.value) {
        toast.error("Veuillez accepter les conditions d'utilisation.");
        return;
      }

      if (form.password !== form.password_confirmation) {
        toast.error("Les mots de passe ne correspondent pas.");
        return;
      }

      loading.value = true;

      try {
        const response = await submitExternalSignup({ ...form });
        toast.success(
          response?.message ||
            "Demande envoyée. Notre équipe vous contactera pour finaliser l'abonnement."
        );
        resetForm();
      } catch (error) {
        const responseErrors = error?.response?.data?.errors;
        if (responseErrors?.company_email?.length) {
          companyEmailError.value = responseErrors.company_email[0];
        }

        fieldErrors.rc = responseErrors?.rc?.[0] || "";
        fieldErrors.ice = responseErrors?.ice?.[0] || "";
        fieldErrors.tp = responseErrors?.tp?.[0] || "";
        fieldErrors.identifiant_fiscal = responseErrors?.identifiant_fiscal?.[0] || "";

        const message =
          error?.response?.data?.message ||
          "Une erreur est survenue lors de l'envoi de la demande.";
        toast.error(message);
      } finally {
        loading.value = false;
      }
    };

    watch(
      () => form.company_email,
      () => {
        companyEmailError.value = "";
      }
    );

    watch(
      () => form.rc,
      () => {
        fieldErrors.rc = "";
      }
    );

    watch(
      () => form.ice,
      () => {
        fieldErrors.ice = "";
      }
    );

    watch(
      () => form.tp,
      () => {
        fieldErrors.tp = "";
      }
    );

    watch(
      () => form.identifiant_fiscal,
      () => {
        fieldErrors.identifiant_fiscal = "";
      }
    );

    return {
      form,
      loading,
      showPassword,
      showConfirmPassword,
      acceptTerms,
      togglePassword,
      toggleConfirm,
      onSubmit,
      companyEmailError,
      fieldErrors,
      displayErrors,
      isSubmitDisabled,
    };
  },
};
</script>

<style scoped>
.section-divider {
  position: relative;
  margin: 1.5rem 0 1rem;
  padding-bottom: 0.35rem;
  border-bottom: 1px dashed rgba(148, 163, 184, 0.45);
}

.section-divider h5 {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.25rem;
  color: #0f172a;
}

.alert {
  border-radius: 12px;
}
</style>
